import { useContext } from "react";
import { BrandThemeContext } from "@/features/theme/context/BrandThemeContext";
import type { BrandThemeContextValue } from "@/features/theme/types/brandTheme.type";

export const useBrandTheme = (): BrandThemeContextValue => {
  const context = useContext(BrandThemeContext);
  if (!context) {
    throw new Error("useBrandTheme must be used within a BrandThemeProvider");
  }
  return context;
};
